
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const features = [
  {
    svg: "/landing/undraw_online-transactions_8chx.svg",
    key: "bankIntegration"
  },
  {
    svg: "/landing/undraw_subscriber_whh0.svg",
    key: "scheduling"
  },
  {
    svg: "/landing/undraw_file-manager_yics.svg",
    key: "bulkManagement"
  },
  {
    svg: "/landing/undraw_product-iteration_r2wg.svg",
    key: "builder"
  },
  {
    svg: "/landing/undraw_online-payments_p97e.svg",
    key: "tracking"
  },
  {
    svg: "/landing/undraw_scrum-board_uqku.svg",
    key: "integration"
  }
];

const getBackgroundColor = (index: number) => {
  const colors = ['bg-[#8791F3]', 'bg-[#A7DCD8]'];
  return colors[index % 2];
};

const getTextColor = (index: number) => {
  const text_colors = ['text-[#F1F6F5]', 'text-[#34375B]'];
  return text_colors[index % 2];
};

const getDescriptionColor = (index: number) => {
  const text_desc_colors = ['text-[#F1F6F5]/85', 'text-[#34375B]/85'];
  return text_desc_colors[index % 2];
};

export const FeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-[#F1F6F5] py-0 pb-20">
      {/* Feature Grid */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.key}
              className={`${getBackgroundColor(index)} rounded-2xl p-8 shadow-lg flex flex-col h-full hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200`}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index, duration: 0.5 }}
                className="flex flex-col h-full"
              >
                <div className="mb-6 flex justify-center">
                  <img
                    src={feature.svg}
                    alt={t(`features.items.${feature.key}.title`)}
                    className="w-32 h-32 object-contain"
                  />
                </div>
                <h3 className={`${getTextColor(index)} text-xl font-bold mb-4`}>
                  {t(`features.items.${feature.key}.title`)}
                </h3>
                <p className={`${getDescriptionColor(index)} text-sm flex-grow`}>
                  {t(`features.items.${feature.key}.description`)}
                </p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
